// Add class on brand page in every third child 
function addClassToThirdVisibleDivs() {
  const divs = document.querySelectorAll('.brands-column');
  // First, clear the 'every-third-visible' class from all divs
  divs.forEach((div) => {
    div.classList.remove('every-third-visible');
  });
  let count = 0;
  // Now, iterate over the divs and add the class to every third visible one
  divs.forEach((div) => {
    if (getComputedStyle(div).display !== 'none') {
      count++;
      if (count % 2 === 0) {
        div.classList.add('every-third-visible');
        // console.log('Class added to:', div.textContent);
      }
      if(count % 6 === 0){
        div.classList.remove('every-third-visible');
      }
    }
  });
}
// Call the function every 1 second (1000 milliseconds)
setInterval(() => {
  // console.log('Interval executed');
  addClassToThirdVisibleDivs();
}, 1000);



$(document).ready(function() {
  // Get filter names from the hidden div and split by commas
  const filterNames = $('.show_filtername').text().split(',').map(function(name) {
    return $.trim(name); // Remove extra spaces
  });

  const filterList = $('#brandFilterList');
  const brandColumns = $('.brands-column');

  let allTypes = [];

  // Collect all data-types from the columns
  brandColumns.each(function() {
    const dataType = $(this).find('.brands-column-iner').data('type');
    
    if (dataType) {
      const types = dataType.split(','); // Split by comma
      $.each(types, function(index, type) {
        const trimmedType = $.trim(type);
        if (!allTypes.includes(trimmedType)) {
          allTypes.push(trimmedType); // Avoid duplicates
        }
      });
    }
  });

  // Create checkboxes only for the filter names that match the ones in the show_filtername div
  $.each(allTypes, function(index, type) {
    if (filterNames.includes(type)) { // Only add checkboxes for matching filter names
      const liElement = $('<li></li>');
      const labelElement = $('<label></label>');
      const checkboxElement = $('<input type="checkbox" class="brand-filter-checkbox">').val(type);

      labelElement.append(checkboxElement).append(type);
      liElement.append(labelElement);
      filterList.append(liElement);
    }
  });

  // Filter functionality (remains the same)
  filterList.on('change', '.brand-filter-checkbox', function() {
    const selectedFilters = $('.brand-filter-checkbox:checked').map(function() {
      return $(this).val();
    }).get();

    brandColumns.each(function() {
      const columnTypes = $(this).find('.brands-column-iner').data('type').split(',').map(type => $.trim(type));
      
      // Check if the column's data-type matches any of the selected filters
      const isMatch = selectedFilters.length === 0 || columnTypes.some(function(type) {
        return selectedFilters.includes(type);
      });

      $(this).toggle(isMatch); // Show/hide based on match
    });
  });

  function toggleClassOnCheckboxes() {
    if ($('#brandFilterList li label input:checked').length > 0) {
      $('.brand_flx').addClass('filter-added');
    } else {
      $('.brand_flx').removeClass('filter-added');
    }
  }

  setInterval(toggleClassOnCheckboxes, 100);
  
  $('#brandFilterList li label input').on('change', function() {
    toggleClassOnCheckboxes();
  });
  toggleClassOnCheckboxes();

  // Brand filter open close functionality (remains the same)
  $(document).click(function(event) {
    if (!$(event.target).closest('.BrandFilterBtn, #brandFilterList').length) {
      $('#brandFilterList').removeClass('show'); // Hide the filter list
    }
  });

  $('.BrandFilterBtn').click(function(event) {
    event.stopPropagation();
    $('#brandFilterList').toggleClass('show'); 
  });

  // Handle the count of selected filters and clear all functionality (remains the same)
  function checkLength() {
    $("ul#brandFilterList").find("input.brand-filter-checkbox").each(function(){
      var numberOfChecked = $('input.brand-filter-checkbox:checkbox:checked').length;
      if (numberOfChecked > 0) {     
        $('button.BrandFilterBtn span').show().text(numberOfChecked);
        $('button.BrandClear_all').show();
      } else {
        $('button.BrandFilterBtn span').hide();
        $('button.BrandClear_all').hide();
      }
    });

    $('button.BrandClear_all').click(function () {
      $("input.brand-filter-checkbox").prop("checked", false);
      $('.brand_flx .brands-column').show();
    });
  }

  setInterval(checkLength, 100);
});


// maga menu js
$(document).ready(function () {
  $('a.mega-menu__link--level-2').hover(function () {
    var dataImage1 = $(this).attr('data-iamge_1');
    var dataImage2 = $(this).attr('data-iamge_2');
    // var dataLink1 = $(this).attr('dataLink_1');
    // var dataLink2 = $(this).attr('dataLink_2');
    var dataLink = $(this).attr('href');
    $('.mega-menu__list_image .Iner_menu__list_image a').attr('href', dataLink )
    
    $('.mega-menu__list_image .list_image_1 img').attr('src', dataImage1 )
    $('.mega-menu__list_image .list_image_2 img').attr('src', dataImage2 )

    // $('.mega-menu__list_image .list_image_1 a').attr('href', dataLink1 )
    // $('.mega-menu__list_image .list_image_2 a').attr('href', dataLink2 )
  });

});

